export const ISO_CODE_MAP = {
  GB: 'en',
  US: 'us',
  IE: 'ie',
  FR: 'fr',
  SE: 'se',
  DE: 'de',
}

export const DEFAULT_ISO_CODE = 'GB'

export const LOCALES = {
  EN: 'en',
  US: 'us',
  IE: 'ie',
  DE: 'de',
  FR: 'fr',
  SE: 'se',
} as const

export const DEFAULT_LOCALE: Locale = 'en'

export const SHORT_LOCALES = Object.values(LOCALES)

export const FORM_COPIES = {
  PLEASE_MAKE_SELECTION: {
    en: 'Please make a selection',
    us: 'Please make a selection',
    ie: 'Please make a selection',
    se: 'Gör ett val',
    fr: 'Faites la sélection',
    de: 'Bitte treffe eine Auswahl',
  },
  REQUIRED: {
    en: 'This field is required',
    us: 'This field is required',
    ie: 'This field is required',
    se: 'Det här fältet är obligatoriskt',
    fr: 'Ce champ est obligatoire',
    de: 'Dieses Feld ist erforderlich',
  },
  SUBMIT: {
    en: 'Submit',
    us: 'Submit',
    ie: 'Submit',
    se: 'Skicka',
    fr: 'Envoyer',
    de: 'Senden',
  },
  ENTER: {
    en: 'Enter',
    us: 'Enter',
    ie: 'Enter',
    se: 'Delta nu',
    fr: 'Entrer',
    de: 'Eingabe',
  },
  ENTER_NOW: {
    en: 'Enter now',
    us: 'Enter now',
    ie: 'Enter now',
    se: 'Delta nu',
    fr: 'Participer',
    de: 'Eingeben',
  },
  OTHER: {
    en: 'Other',
    us: 'Other',
    ie: 'Other',
    se: 'Annat',
    fr: 'Autre',
    de: 'Andere',
  },
  INVALID_EMAIL: {
    en: 'Invalid email',
    us: 'Invalid email',
    ie: 'Invalid email',
    se: 'Ogiltig e-post',
    fr: 'Email invalide',
    de: 'Ungültige E-Mail',
  },
}
